export enum TypeBestOf {
    DAYS = 1,
    THEME
}